import company from './zgcz'

// const BASE_URL = window.location.origin
// const BASE_URL = 'https://zghg.yataiwuliu.com/'
// const BASE_URL = 'http://localhost:65534'
// const BASE_URL = 'https://bkfx.eyesnews.cn/'
// const BASE_URL = 'https://grrb.yataiwuliu.com/'
// const BASE_URL = 'https://bmkxjs.nsstec.org.cn/'
// const BASE_URL = 'https://zgrd.yataiwuliu.com/'
// const BASE_URL = 'https://jybfx.eyesnews.cn/'
// const BASE_URL = 'https://wqfx.eyesnews.cn/'
const BASE_URL = 'https://zgcz.yataiwuliu.com/'
// const BASE_URL = 'https://rmjc.yataiwuliu.com/'
// const BASE_URL = 'https://studytimes.yataiwuliu.com/'
// const IMG_BASE_URL = 'https://bmkxjs.nsstec.org.cn/pc/img/'
// const IMG_BASE_URL = 'https://grrb.yataiwuliu.com/pc/img/' // grrb
// const IMG_BASE_URL = 'https://zgjg.yataiwuliu.com/pc/img/' // zgjg
// const IMG_BASE_URL = 'https://bkfx.eyesnews.cn/pc/img/' // gzrb
// const IMG_BASE_URL = 'https://jybfx.eyesnews.cn/pc/img/' // gzjyb
// const IMG_BASE_URL = 'https://fzbfx.eyesnews.cn/pc/img/' // gzfzb
// const IMG_BASE_URL = 'https://wqfx.eyesnews.cn/pc/img/' // wanqing
const IMG_BASE_URL = 'https://zgcz.yataiwuliu.com/pc/img/' // zgcz
// const IMG_BASE_URL = 'https://rmjc.yataiwuliu.com/pc/img/' // zgcz
// const IMG_BASE_URL = 'https://bmkxjs.nsstec.org.cn/pc/img/' // bmkx
// const IMG_BASE_URL = 'https://zgrd.yataiwuliu.com/pc/img/' // zgrd
// const IMG_BASE_URL = 'https://studytimes.yataiwuliu.com/pc/img/' // xxsb

export default {
  BASE_URL: BASE_URL,
  IMG_BASE_URL: IMG_BASE_URL,
  ISSUE_RANGE: company.ISSUE_RANGE,
  invoiceTypes: company.invoiceTypes,
  title: company.title,
  icp: company.icp,
  APP_CODE: company.APP_CODE,
  copyright: company.copyright,
  accountInfo: company.accountInfo,
  payWay: company.payWay,
  ORDER_STATE: company.ORDER_STATE,
  invoiceEnable: company.invoiceEnable,
  TIP_SHOW: company.TIP_SHOW,
  B2B_V2: company.B2B_V2,
  org: company.org,
  invoice: company.invoice,
  footer: company.footer,
  popInfo: company.popInfo,
  help: company.help,
  labelInfos: company.labelInfos
}
